import api from './base'
import { endpoints } from './base'
import { useAuthStore } from '../../stores/auth'

// Interface for organization creation payload (matching backend schema)
export interface OrganizationCreatePayload {
  title: string
  body?: string
  user_id?: number
}

// Interface for user profile update payload (matching backend schema)
export interface UserProfileUpdatePayload {
  full_name?: string
  email?: string
  password?: string
}

// Функция для авторизации
export const login = async (email: string, password: string) => {
  const formData = new URLSearchParams()
  formData.append('username', email)
  formData.append('password', password)
  const response = await api.post(endpoints.auth.login(), formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
  return response
}

// Функция для верификации 2FA
export const verify2fa = async (email: string, password: string, code: string) => {
  const response = await api.post(endpoints.auth.verify2fa(), {
    credentials: { email, password },
    verification_code: { code },
  })
  return response
}

// Функция для выхода из системы
export const logout = async () => {
  try {
    // Очищаем токен на клиенте
    const authStore = useAuthStore()
    authStore.logout()

    // Можно добавить вызов API для инвалидации токена на сервере
    // await api.post('/auth/logout')

    return true
  } catch (error: any) {
    console.error('Logout error:', error.response || error)
    throw error
  }
}

// Функция для обновления токена
export const refreshToken = async () => {
  try {
    const response = await api.post('/auth/refresh-token')
    const authStore = useAuthStore()
    authStore.setToken(response.data.access_token)
    return response.data
  } catch (error: any) {
    console.error('Token refresh error:', error.response || error)
    throw error
  }
}

// Function to request password reset email
export const requestPasswordReset = async (email: string) => {
  try {
    // The endpoint expects { "email": "user@example.com" }
    const response = await api.post(endpoints.auth.requestPasswordReset(), { email })
    return response // Return the full response object
  } catch (error: any) {
    console.error('Request password reset error:', error.response || error)
    throw error // Re-throw the error to be handled by the component
  }
}

// Function to reset password using token
export const resetPassword = async (token: string, new_password: string) => {
  try {
    // The endpoint expects { "token": "...", "new_password": "..." }
    const payload = { token, new_password }
    const response = await api.post(endpoints.auth.resetPassword(), payload)
    return response // Return the full response object
  } catch (error: any) {
    console.error('Reset password error:', error.response || error)
    throw error // Re-throw the error to be handled by the component
  }
}

// Function to create an organization
export const createOrganization = async (payload: OrganizationCreatePayload) => {
  try {
    if (!payload.user_id) {
      console.warn('Missing user_id in createOrganization payload, it should be added in the store')
    }

    const response = await api.post(endpoints.organizations.create(), payload)
    return response // Return the full response object
  } catch (error: any) {
    console.error('Create organization error:', error.response || error)
    throw error // Re-throw the error to be handled by the store/component
  }
}

// Function to update user profile (/users/me)
export const updateUserProfile = async (payload: UserProfileUpdatePayload) => {
  try {
    // Use the endpoint defined for updating the current user
    const endpoint = endpoints.users.me.update()
    const response = await api.put(endpoint, payload)
    return response // Return the full response object
  } catch (error: any) {
    console.error('Update profile error:', error.response || error)
    throw error // Re-throw the error
  }
}

// Function to verify current password
export const verifyCurrentPassword = async (currentPassword: string) => {
  try {
    const response = await api.post(endpoints.users.me.verifyPassword(), {
      current_password: currentPassword,
    })
    return response // Return the full response object
  } catch (error: any) {
    console.error('Verify password error:', error.response || error)
    throw error // Re-throw the error to be handled by the component
  }
}
